// Mirrors src/Domain/Enums/HazardResponse.cs — serialized as integers (enum value).
// "Unknown" is a real answer (no data for the endpoint), which is why it is the default.
export const HAZARD_RESPONSE = Object.freeze({
  UNKNOWN: 0,
  YES: 1,
  NO: 2,
});

export const HAZARD_RESPONSE_LABELS = Object.freeze({
  [HAZARD_RESPONSE.UNKNOWN]: 'Unknown',
  [HAZARD_RESPONSE.YES]: 'Yes',
  [HAZARD_RESPONSE.NO]: 'No',
});

export const HAZARD_RESPONSE_OPTIONS = Object.freeze([
  HAZARD_RESPONSE.YES,
  HAZARD_RESPONSE.NO,
  HAZARD_RESPONSE.UNKNOWN,
]);

// The four hazard-classification endpoints held on an API, in the order they are asked.
// `short` is what the list grid shows when the answer is Yes.
export const API_HAZARD_FIELDS = Object.freeze([
  { field: 'genotoxicant', label: 'Genotoxicant', short: 'Genotoxic' },
  { field: 'reproductiveToxicant', label: 'Reproductive / developmental toxicant', short: 'Reprotoxic' },
  { field: 'carcinogen', label: 'Carcinogen', short: 'Carcinogen' },
  { field: 'highlySensitizing', label: 'Highly sensitizing potential', short: 'Sensitizer' },
]);
